import React, { useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  Row,
  Col,
} from "react-bootstrap";

import {
  FaClock,
  FaPhoneAlt,
  FaShoppingCart,
  FaSearch,
  FaBars,
  FaFacebookF,
  FaTwitter,
  FaGooglePlusG,
  FaYoutube,
  FaPinterestP,
  FaSignInAlt,
  FaHeadset,
} from "react-icons/fa";
import "./../App.css"

const Header = () => {
    const [showMenu, setShowMenu] = useState(false);
  return (
    
    <>
    
      {/* Top Bar */}
      <div
        className="bg-dark text-white py-2"
        style={{ fontSize: "14px" }}
      >
        <Container>
          <Row className="align-items-center">

            <Col
              lg={4}
              md={6}
              className="text-center text-md-start mb-2 mb-md-0"
            >
              <FaClock className=" me-2"style={{color:"var(--primary-color)"}} />
              Mon - Sat 9 AM -  6 PM
            </Col>

            <Col
              lg={4}
              className="d-none d-lg-block text-center"
            >
              
            </Col>

            <Col
              lg={4}
              md={6}
              className="text-center text-md-end"
            >
             
              <FaFacebookF className="mx-2" />
              <FaGooglePlusG className="mx-2" />
              <FaYoutube className="mx-2" />
         
            </Col>

          </Row>
        </Container>
      </div>

      {/* Main Header */}

      {/* <Navbar bg="white" expand="lg" className="shadow-sm py-3">
        <Container> */}
        <Navbar bg="white" expand="lg" className="shadow-sm py-0">
<Container fluid className="px-4 px-lg-5">
        
<Navbar.Brand href="/" className="d-flex align-items-center">
  <img
    src="/krimotion_logo.jpeg"
    alt="Krimotion Logo"
    width="50"
    height="50"
    className="me-2"
  />

  <h1 className="fw-bold mb-0" style={{ color: "#222" }}>
    <span style={{ color: "var(--primary-color)" }}>K</span>RIMOTION
  </h1>
</Navbar.Brand>


<div className="header-divider"></div>

          <div className="ms-auto d-flex align-items-center">

<div className="ms-auto d-flex align-items-center">

  {/* Support */}
  <div className="d-none d-md-flex align-items-center me-4">
<div className="header-divider"></div>
    <FaHeadset
      size={34}
      className="me-3"
      style={{ color: "var(--primary-color)" }}
    />

    <div>
      <small className="text-muted d-block">
        Get Quick Support
      </small>

      <h6 className="fw-bold mb-0">
        236-799-5500
      </h6>
      
    </div>
    

  </div>
  

  
  <div
    className="menu-btn"
    onClick={() => setShowMenu(true)}
  >
    <FaBars size={22} />
  </div>

</div>
          <div

>
           
             

            </div>
 
          </div>

  <div className={`sidebar1 ${showMenu ? "show" : ""}`}>
  <button
    className="close-btn text-white"
    onClick={() => setShowMenu(false)}
  >
    ×
  </button>

  <Nav className="flex-column">
    <Nav.Link href="/" className="text-white hover-fw-bold">Home</Nav.Link>
    <Nav.Link href="/about" className="text-white hover-fw-bold">About</Nav.Link>
    <Nav.Link href="/contact" className="text-white hover-fw-bold">Contact</Nav.Link>
    <Nav.Link href="/privacy-policy" className="text-white hover-fw-bold">Privacy Policy</Nav.Link>
  </Nav>
</div>

{showMenu && (
  <div
    className="overlay"
    onClick={() => setShowMenu(false)}
  ></div>
)}
        </Container>
      </Navbar>
    </>
  );
};

export default Header;